<div class="hwb-wrap">
  <h3 class="hwb-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="hwb-mixer" [style.--hwb-thumb]="thumb">
    <!-- Three sliders, no boxes: pick a hue, then mix white and black into it. -->
    <div class="hwb-controls">
      <div class="hwb-control">
        <div class="hwb-row">
          <label class="hwb-label" for="hwb-hue">Hue</label>
          <input id="hwb-hue" class="hwb-slider hwb-hue-slider" type="range" min="0" max="359" step="1"
                 [value]="hue" (input)="onHue( $any( $event.target ).value )" aria-label="Hue">
        </div>
        <span class="hwb-value">{{ hueLabel }}&deg;</span>
      </div>
      <div class="hwb-control">
        <div class="hwb-row">
          <label class="hwb-label" for="hwb-white">Whiteness</label>
          <input id="hwb-white" class="hwb-slider" type="range" min="0" max="100" step="1"
                 [style.background]="whiteTrack"
                 [value]="white" (input)="onWhite( $any( $event.target ).value )" aria-label="Whiteness">
        </div>
        <span class="hwb-value">{{ whiteLabel }}%</span>
      </div>
      <div class="hwb-control">
        <div class="hwb-row">
          <label class="hwb-label" for="hwb-black">Blackness</label>
          <input id="hwb-black" class="hwb-slider" type="range" min="0" max="100" step="1"
                 [style.background]="blackTrack"
                 [value]="black" (input)="onBlack( $any( $event.target ).value )" aria-label="Blackness">
        </div>
        <span class="hwb-value">{{ blackLabel }}%</span>
      </div>
    </div>

    <!-- The pure hue, and beside it the mix with white and black folded in. Drag W or B
         and the mix pulls away while the pure hue holds; drag the hue and both move. -->
    <div class="hwb-results">
      <div class="hwb-result">
        <div class="hwb-swatch" [style.background]="pureHex"></div>
        <span class="hwb-result-name">Pure Hue</span>
        <span class="hwb-result-hex">{{ pureHex }}</span>
      </div>
      <div class="hwb-result">
        <div class="hwb-swatch" [style.background]="mixHex"></div>
        <span class="hwb-result-name">The Mix</span>
        <span class="hwb-result-hex">{{ mixHex }}</span>
      </div>
    </div>

    <!-- The mix written the way CSS writes it. The overflow note always keeps its
         line so showing it never grows the panel. -->
    <div class="hwb-reading">
      <span class="hwb-reading-code">{{ hwbString }}</span>
      <span class="hwb-reading-note" [class.is-visible]="overflowed" [attr.aria-hidden]="!overflowed">white and black filled the mix, the hue is gone</span>
    </div>
  </div>
</div>
